import request from '@/util/request'

// 查询ss列表
export function listMessage(query) {
  return request({
    url: '/iot/message/list',
    method: 'get',
    params: query
  })
}

// 查询ss详细
export function getMessage(id) {
  return request({
    url: '/iot/message/' + id,
    method: 'get'
  })
}
export function warnNumberCount(enterpriseId) {
  return request({
    url: '/iot/message/warnNumberCount/' + enterpriseId,
    method: 'get'
  })
}


// 新增ss
export function addMessage(data) {
  return request({
    url: '/iot/message',
    method: 'post',
    data: data
  })
}

// 修改ss
export function updateMessage(data) {
  return request({
    url: '/iot/message',
    method: 'put',
    data: data
  })
}

// 删除ss
export function delMessage(id) {
  return request({
    url: '/iot/message/' + id,
    method: 'delete'
  })
}

//全部已读
export function allReadyMessage(id) {
  return request({
		url: '/iot/message/readAllMessage',
		method: 'post',
  })
}
